import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { asyncStorageStorage } from "@lookiero/sty-psp-storage";
import { queryClientContext } from "../hooks/useQueryClient";
import { Store } from "../shared/types";

const useGetAsyncStorage = () => {
  const queryClient = useContext(queryClientContext);

  const { data } = useQuery<Store>(
    {
      queryKey: ["getAsyncStorage"],
      queryFn: async () => {
        const storage = asyncStorageStorage<unknown>();

        return {
          set: (key, obj) => storage.write(key, obj),
          get: (key) => storage.read(key),
          has: async (key) => (await storage.read(key)) !== null,
          remove: (key) => storage.remove(key),
        };
      },
      gcTime: Infinity,
      staleTime: Infinity,
    },
    queryClient,
  );

  return data;
};

export { useGetAsyncStorage };
